module.exports = __webpack_public_path__ + "img/videovigilancia.32faf15d.png";